import "./404.a09eb381.js";


      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0b37"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0b37"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
// Copyright (C) 2026 FlexiProof. All rights reserved.
//
// This source code file is a part of free software licensed under the terms of
// the MIT License as published by the Massachusetts Institute of Technology:
// you can use, copy, modify and distribute any part of it without limitation,
// subject to the conditions contained within that license.
//
// This source code file, and the software it forms a part of, IS PROVIDED "AS
// IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED. See the MIT License
// for more details.
//
// You should have received a copy of the MIT License along with this source
// code file in the root of this repository. If not, see one of the following
// 3rd party sites for a copy of the license template:
// - <https://opensource.org/licenses/MIT>
// - <https://choosealicense.com/licenses/mit>
// - <https://spdx.org/licenses/MIT>
/**
 * @file Entrypoint for web calculator.
 * @author James Reid
 */ // @ts-check
// @@imports-package

var $lYDp5 = parcelRequire("lYDp5");

var $70MgW = parcelRequire("70MgW");

var $1m6mJ = parcelRequire("1m6mJ");

var $jBgIf = parcelRequire("jBgIf");
// @@body
/**
 * @todo Add youtube installation links for each item (particularly extras).
 * @todo Review html tags used versus generic div structure.
 * @todo Define more components (such as cards) as web components.
 * @todo Add optional upgrades/downgrades to each product (e.g. patch lap edge).
 * @todo Add colors used in pixi for fills and strokes etc. to the state object.
 * @todo Add redraw events which trigger redraw of all or parts of canvas.
 * @todo Add pan and zoom with mind for touch devices and mouse devices. When
 * panned/zoomed, disable automatic resizing, and add recenter option.
 * @todo Add settings button to toolbar.
 * @todo Update tween to return promise, so that re-render can be conditionally
 * called upon completion.
 * @todo Move spritesheet loader to utils.
 * @todo Change edge editor tool to control min length set to not cause errors.
 * @todo Move step runner callback to state value on each step instead of get
 * runner.
 * @todo Review use of "inactive" vs "closed" in styles, and establish a
 * consistent rule (add new class for fade animations?).
 * @todo Define custom elements by exporting them in default array with static
 * tagName properties, using these to define custom elements in loop.
 * @todo Change edge assets to use darker blue as reflective of roof calc
 * branding.
 * @todo Change selector to deck folder, and rename deck to editor.
 * @todo Add dropdown for edit instructions.
 * @todo Move deck image generation for selector into web worker, and save the
 * image to a template component, such that when the selector page is reused,
 * the images do not have to be regenerated (alternatively display loading
 * screen when loading this step).
 * @todo Add element scoped render lucide icons method.
 * @todo Move bom functions into bom step.
 * @todo Clean up sass components directory (review old styles, nest and remove
 * redundant rules).
 * @todo Wrap multiple fade calls in load/unload popover etc with promise all,
 * and remove use of await such that fades happen at the same time.
 * @todo Remove previous button from all edge editors (except main?) but allow
 * users to click edge to select (including on length).
 * @todo Fix competency declaration modal content with respect to text alignment
 * and font sizes. Use larger text for main message, and put only details in the
 * small print.
 * @todo Add rotate option to deck editor toolbar.
 * @todo Hide some columns in product cards at smaller screen sizes.
 * @todo Add merchant SKU codes to bill of materials step card breakdowns. In
 * order to display correctly on mobile, set some columns in table to be hidden
 * at smaller screen sizes.
 * @todo Add unit price *and* line subtotal to breakdowns in bill of materials
 * step.
 * @todo Add per linear price to membrane card breakdowns.
 * @todo Move preset deck declarations into web scripts.
 * @todo Fix clicking on edge measurement not opening edge editor bug at final
 * step of deck definition.
 * @todo Change layout render functions to "mount" and add "unmount" method and
 * reflect to stepped container methods.
 * @todo Change all modal cards to include an icon header div as on dashboard.
 * @todo Refactor switch edge logic on edge length editor to reduce repetition
 * of tween end event listeners.
 * @todo Update calculator to use metal edge trim joiners at join between 2
 * length of trim rather than adding an overlap. Possibly add this as
 * configuration value to choose between the two metal trim joining options.
 * @todo Add deck substrate to quote review page (/quote).
 * @todo Remove/reduce number of templates under /content in html templates.
 * This content should be moved to the correct layout file instead to
 * streamline directories.
 * @todo Change merchant search box to reflect the updated interface/setup used
 * on backend.
 * @todo Update descriptions under each header to match (currently text looks
 * too large).
 * @todo Fix fetching query parameters from parent (use window message
 * listener for query events passed in). Use post message and await response
 * method.
 * @todo Fix quote value showing up on conversion cards.
 * @todo Enforce adding email to all quotes such that client has a email ref
 * for the quote which has been generated (better paper trail if there are
 * issues).
 * @todo Remove sales mode from both quote and root page query params, and use
 * mode query instead (set mode=sales).
 * @todo Compare existing line items to generated bom on quote review page.
 * @todo Move client details to a serialised string on quote review for sales.
 * @todo Allow user details inferred from parent page to be passed into calc to
 * pre-populate user details for save and and to basket quotes.
 * @todo In sales mode, allow sales user to select the price list they want the
 * quote to be generated with. Also allow the user to change the default hide
 * basket and hide prices values.
 * @todo Review refresh button at end of calculator. Needs to remove quote
 * modify query params, but maintain any params injected by parent page.
 * @todo Remove await statements on stepped container load/unload methods etc,
 * and instead build promise array for all fade animation which can happen
 * simultaneously, and await Promise.all on these promises before executing
 * synchronous/order dependant fades.
 * @todo Add icon headers to cards displayed during deck spec process, and
 * include small text underneath dismiss button with additional details.
 * @todo Add ability to pass in serialized client details to pre-populate save
 * quote information.
 * @todo Update table styling to be more inline with dashboard styling which is
 * generally clearer.
 * @todo Try to remove align end, space-between class modifiers etc. (the ones
 * which just change one style in favour of adding custom local layouts based
 * on container ids.).
 * @todo Change titles in product card slots to be h4 directly instead of spans.
 * @todo Add sku codes or similar to product cards so that web component can
 * find breakdown and subtotal in App state bill of materials.
 * @todo Change any custom events to prefixed kebab case "roof-calc:event-name".
 * @todo Fetch all images and save to this repo so that app is independent of
 * other site changes.
 * @todo Host all product images on DO CDN (S3 object or similar) and change all
 * image URLs to match in products.
 * @todo Transition to BEM styling, but using nesting in SCSS to omit need for
 * repeating specifier in class list. For example "card__list" would just have
 * be "__list" element class when nested under tag with "card" block class.
 * Having "card__list" is redundant (used in CSS to ensure unique classes) as
 * SCSS nesting will automatically generate ".card .__list" selector.
 * - See https://getbem.com/
 * - See https://andrew-barnes.medium.com/bem-and-sass-a-perfect-match-5e48d9bc3894
 * - Use components directory as existing for reusable blocks (cards, lists
 * etc.)
 * - Use layout directory for id-based modification of layout exceptions.
 * - Establish order in nesting: block -> block modifiers, element -> element
 * modifiers
 * - Add prefix to modifiers (perhaps mod-- so that mod becomes a block, and
 * all --xyz are modifiers)
 * - Add prefix to animations (perhaps anim--)
 * @todo Add prefix to template ids (perhaps tmpl__ so that tmpl is block, and
 * each template is an element).
 * @todo Remove trim upgrade section when there are no PVC trims in the order.
 * @todo Create "data-role" attributes where lots of buttons together would be
 * better identified like this than with primary/secondary classes.
 * @todo Fix widths of list select elements to be consistent with measurement
 * inputs except where they are causing wrapping/overflow on mobile.
 * @todo Fix last step detailed breakdown rendering.
 * @todo change collapsible container to automatically add collapsible tag part
 * populated using data attributes.
 * @todo Remove period from end of image alt descriptions.
 * @todo Update quote breakdown card to show line item *difference* between
 * currently selected option and new card.
 * @todo Review images downloaded on landing page (loading screen), and consider
 * loading these resources in the background after the client continues from the
 * start screen. Consider converting png to webp images where possible to save
 * download sizes further (definitely do this for start page images).
 * @todo Fix dropdown rendering offscreen on mobile
 * @todo Fix upgrade prices and selected indications in brackets when the hide
 * prices flag is set; currently these will not be displayed despite showing
 * selected/unavailable status etc.
 * @todo Fix/modify quote rendering page to derive rendered content directly
 * from line items now that details are stored in database.
 * @todo Add deploy notes to test build in local using http-server on minified
 * parcel build output to ensure that no other issue have arisen.
 * @todo Fix update bug when updating quote from backend causing quote to then
 * not render correctly.
 * @todo Add create element wrapper for creating element with preset classes
 * from given HTML element instance.
 * @todo Automatically infer custom elements to add in initial method from
 * classes exported by components library - attach tag names to each class.
 * @todo Add breakdown to top of options card in dropdown, then add options
 * details to the breakdown modals (change to "Option Details"). Add option
 * details to modal (membrane, trim details etc.) then change breakdown to only
 * show the removed and added line items.
 * @todo Rename BOM cards to sections.
 * @todo Change h4 tags to h3, remove after styling on h3 tags, reduce font size
 * on h3 tags to be closer to h4. Change h5 tags to h4, change h4 styling to
 * match h5 styling but with 1rem font size.
 * @todo Add membrane layout and change seam direction option back to new quote
 * page (add in quote breakdown collapsed container).
 * @todo Add casting to clone template by passing an optional constructor which
 * should match the cloned template.
 * @todo Review center text align on all card components; add center modifier
 * which is only applied to the cards which need to be centred.
 * @todo Add Guide buttons for trims, tools and consumable kits (same as
 * membrane guide).
 * @todo Check for step nav (previous, next) being correctly enabled/disabled
 * between steps particularly at quote step such that people cannot skip through
 * steps before the proper loading has occurred.
 * @todo Change quote overview section to have *one* collapsible container which
 * nests a tabbed container with "Specification", "Layout", and "Breakdown" for
 * showing the deck specification set up by user, the membrane layout and the
 * line item breakdown of the quote.
 * @todo Review modals overflowing without ability to scroll to bottom when too
 * much vertical content is in them (particularly on mobile). Potentially add
 * close/action buttons at bottom of modal to a sticky container.
 * @todo Change template IDs to data-accessor IDs instead.
 * @todo Add error page for failing to fulfill quote, asking user to try again
 * later.
 * @todo Build spritesheet on the fly by stitching together the images already
 * loaded into the page for the dropdown to save asset loading.
 * @todo Look into responsive images (srcset images) for appropriate resources
 * for rendering across display sizes.
 * @todo Change naming in scripts and markup of bill of materials to quote
 * summary/quote review instead.
 * @todo Change step names to "Select" (select shape and deck material),
 * "Configure" (set dimensions, customise deck etc.), "Quote" (quote review).
 * @todo Add optional element type checking to clone template method.
 * @todo Add membrane weight to membrane breakdown section.
 * @todo Consider larger text size in modals at the top with smaller details in
 * the lists underneath.
 * @todo Extend measurement input for a deck measurement input which changes
 * the deck rendered units too (currently on generic measurement input which
 * should not have deck-specific rules).
 * @todo Add methods for setting measurement input units based on a method
 * rather than a switch toggle method.
 * @todo Review rendered order of bill of materials under dropdown (currently
 * extras are appearing towards top).
 * @todo Add close toolbar to all modal cards.
 * @todo Add quote protection on quotes which have been added to basket which
 * includes a button to duplicate the quote into a new saved state for
 * modification.
 * @todo Consider removing/altering wait on final page after saving quote whilst
 * app waits for backend to finish posting quote email.
 * @todo Re-enable cache on calc page for RRD once trial period is over and we
 * are definitely not reverting to old calculator.
 * @todo Add final stock check when updating calculator config in "update"
 * method.
 * @todo Add project reference to save quote interface for front and backend.
 * @todo Fix pixi deck image rendering queue (currently no queue, just working
 * on rudimentary events which could still cause collisions).
 * @todo Add notification to quote emails that prices are correct at time of
 * issuing quote, and may be subject to change.
 * @todo Add error logging to failed quote generations, emailing admins with
 * details of failed quote.
 * @todo Remove old deck rendering logic which has been replaced by the web
 * component.
 * @todo Add mobile scroll emulation at the bottom of substrate and quote pages
 * so that if user keeps scrolling, the parent page scrolls.
 * @todo Toolbar tools to add:
 * - Add feature (rooflight, box gutter, void, top drains, horizontal drains).
 * - Add membrane cut? (Can be done automatically on final page with user
 * config details to limit membrane weight, additionally this would be an epdm
 * specific tool on an otherwise generic page)
 * - Go back to guided mode.
 * - View deck information (minimum membrane weight, area)? (This information
 * could also (and is) displayed on the final page, and is also system
 * specific).
 * @todo Add deck specification info/guide to toolbar which loads modal with
 * instructions on what to do.
 * @todo Disable start button from start screen when modal "continue" button is
 * pressed on competency declaration so that the start button cannot be pressed
 * twice.
 * @todo Add line item pricing at time of quote creation/last update to the misc
 * data object on each quote.
 * @todo Resolve running stock bug on trims.
 * @todo Add new/modify membrane guide to dynamically hide the 1.14mm membrane
 * when it is not available as is done with the product option.
 * @todo Change roofs over 100sqm to use RUSS strip perimeter instead of the all
 * contact bonding option (requires 75mm additional primer and 75mm additional
 * contact bonding for installation around entire perimeter).
 * @todo Add apex option to deck editor such that sales users can edit apex
 * details on shed kits. Add rendering for apexes everywhere.
 * @todo Add global method to instantiate calculator such that it can be called
 * on substrate and/or bill of materials page depending on roof deck type.
 * @todo Fix apex render positioning on shed page in canvas.
 * @todo Fix typings with respect to ApexHeightRenderer (needs to extend
 * renderer without conflicts with DeckRenderer vs ApexRenderer).
 * @todo Refactor edges or apexes (and future features) such that the isDefined
 * logic is either all on the Deck class, or all on the classes of each feature.
 * Alternatively establish clean separation for which things are defined on
 * which classes.
 * @todo Add support for setting multiple apexes (clicking next should cycle
 * through them) on apex page; currently only supports setting one apex.
 * @todo Change expected renderer type in state etc. to base renderer class for
 * compatibility with apex renderer.
 * @todo Review performance issues when switching between membrane layouts on
 * larger roofs - at the very least add a loader to indicate that the switch is
 * being made. Consider pre-calculating membrane options whenever final page is
 * loaded, and cache them in calculator class - performance issues only present
 * on website in live.
 * @todo Change primary colour for all styles to black with "darker" colour
 * being a grey (or inverted) - change in deck rendering and in dashboard.
 * @todo Ensure that quote page reflects pricing *at time of quote* with a note
 * that pricing and availability may change at short notice at the bottom of the
 * quote.
 * @todo Fix deck edge specification to specify no contact on pvc or no edges.
 * @todo Swap --clr-primary-500 and -800 in styles in light of black scheme.
 * @todo Remove vat price from BOM (no longer used).
 * @todo Implement tape roll length tiling loop similar to trims (greedy algo
 * selecting longest length until not required, then choosing shorter length).
 * This relies on tapes *always* doubling in size or being an multiple of other
 * tapes in the calculator, for example 1 > 7.5 > 15 > 30.5.
 * @todo Fix membrane layout bug showing overlaying images when changing between
 * deck shapes.
 * @todo Add options on complex roofs to limits number of seams (enable options
 * to specify membranes using entire bounding box of deck).
 * @todo Enable spaces in surnames/first names for save quote.
 * @todo Implement escape button on dashboard when making a new quote (esc.
 * should close the tab).
 * @todo Fix seam tape overspecification between deck zones providing tape for
 * all overhangs.
 * @todo Fix error logging in console when refreshing deck on edit step.
 * @todo Fix imperial selection matching with deck editor popover (if you select
 * imperial during type selection, then the edge editor will still start in
 * metric).
 * @todo Fix quote page rendering so that bill of materials shows exactly the
 * products specified directly from bill of materials and correct membrane
 * layout too from zone ID. Do *not* reconstruct quote dynamically!
 */ // Execute page setup scripts. CAUTION: Web component definitions use a polyfill
// and *must* be top-level.
(0, $jBgIf.defineCustomElements)([
    {
        name: "roof-calc-app",
        element: (0, $lYDp5.App)
    }
]);
(0, $jBgIf.setHoverable)();
// Ping API if in staging environment to dry-run requests against IP whitelist.
// If request is not from a whitelisted IP address, this and all other requests
// will be refused, rendering error modal.
if (/^https:\/\/staging\..*$/.test(window.location.href)) (0, $jBgIf.apiRequest)("../");
// Instantiate stepped container wrapper with correct calculator steps depending
// on roof type inferred from URL query parameters.
const $7e0010a8c2daea7e$var$queryParams = new URLSearchParams(window.location.search);
const $7e0010a8c2daea7e$var$roofType = $7e0010a8c2daea7e$var$queryParams.get("deckType") || "flat";
const $7e0010a8c2daea7e$var$steps = $7e0010a8c2daea7e$var$roofType === "shed" ? [
    (0, $1m6mJ.startScreen),
    (0, $1m6mJ.eavesEditor),
    (0, $1m6mJ.apexEditor),
    (0, $1m6mJ.billOfMaterials),
    (0, $1m6mJ.endScreen)
] : [
    (0, $1m6mJ.startScreen),
    (0, $1m6mJ.deckEditor),
    (0, $1m6mJ.substrateSelector),
    (0, $1m6mJ.billOfMaterials),
    (0, $1m6mJ.endScreen)
];
const $7e0010a8c2daea7e$var$container = new (0, $70MgW.SteppedContainer)($7e0010a8c2daea7e$var$steps, ()=>{});
// [
//     startScreen,
//     // deckSelector, // replace with deck selector modal on first page
//     // deckEditor,
//     eavesEditor,
//     apexEditor,
//     substrateSelector,
//     billOfMaterials,
//     endScreen
// ]
// Instantiate singleton app wrapper and mount to dom as first child of body.
const $7e0010a8c2daea7e$var$app = new (0, $lYDp5.App)({
    container: $7e0010a8c2daea7e$var$container
});
document.body.prepend($7e0010a8c2daea7e$var$app) // @@no-exports
;


//# sourceMappingURL=pages.bd284ad6.js.map
